import { Chip, ChipProps } from '@mui/material';
import styled from 'styled-components';
import { RoutalPalette } from './Colors';

interface StopRestrictionChipProps {
  backgroundColor?: string;
  height?: string;
  borderRadius?: string;
  padding?: string;
  marginRight?: string;
}

const StopRestrictionChip = styled(Chip)<StopRestrictionChipProps>`
  height: ${(props) => props.height || `18px`} !important;
  border-radius: ${(props) => props.borderRadius || `2px`} !important;
  padding: ${(props) => props.padding || `2px 4px`} !important;
  margin-right: ${(props) => props.marginRight || `4px`} !important;
  background-color: ${(props) => props.backgroundColor || RoutalPalette.neutral02} !important;
  & .MuiChip-label {
    padding: 0 !important;
  }
`;

interface RoutalChipProps extends ChipProps, StopRestrictionChipProps {}

export const RoutalChip = ({
  backgroundColor,
  height,
  borderRadius,
  padding,
  marginRight,
  ...chipProps
}: RoutalChipProps) => {
  return (
    <StopRestrictionChip
      backgroundColor={backgroundColor}
      height={height}
      borderRadius={borderRadius}
      padding={padding}
      marginRight={marginRight}
      {...chipProps}
    />
  );
};
